<div class="infocard" [attr.style]="(model.ssty||'')">
    <div class="row align-middle">
        <div class="col" *ngIf="model.chtm_id">
            <app-chtm [ido]="model.chtm_id"></app-chtm>
        </div>
        <div class="col" *ngIf="model.chart_id">
            <app-chart [ido]="model.chart_id"></app-chart>
        </div>
    </div>
</div>